import styled from 'styled-components';

export const StyledPrimaryInput = styled.input`
  padding: 0.5rem 0.5rem;
  box-sizing: border-box;
  border-radius: 0.4rem;
  border: 0;
  padding: 1rem;
  width: 100%;
`;
